__turbopack_context__.v({
  "background": "CollectionSectionFDW-module__g1ZufW__background" + " " + __turbopack_context__.i(13628)["background"],
  "section": "CollectionSectionFDW-module__g1ZufW__section" + " " + __turbopack_context__.i(13628)["section"],
  "title": "CollectionSectionFDW-module__g1ZufW__title" + " " + __turbopack_context__.i(13628)["title"],
  "topBar": "CollectionSectionFDW-module__g1ZufW__topBar" + " " + __turbopack_context__.i(13628)["topBar"],
});
